import React, { useState, PureComponent, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import Carousel from 'react-bootstrap/Carousel';
import "../App.css";
import Header from "./header";
import SideNav from "./sidenav";

import Product2 from "../assets/images/product-2.jpg";
import Product3 from "../assets/images/product-3.jpg";
import Product4 from "../assets/images/product-4.jpg";
import Veg from "../assets/images/veg.png";
import NonVeg from "../assets/images/non-veg.png";
import CheckImg from "../assets/images/check.png";

import DeleteAlert from "../assets/images/deleteAlert.png";
import Alert from "../assets/images/alert-1.png";
import { Button } from "react-bootstrap";
import {
    getProductionList,
    ProductListAction,
    productStatusAction,
    removeProductAction,
    subCategoryList,
} from "../redux/actions/productAction";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
const initialState = {
    Deleteshow: false,
    productsData: [],
    BlockModal: false,
    UnblockModal: false,
    _id: "",
    search: "",
    sub_category_Id: "",
    store: "",
    subCategoryData: [],
    productId: "",
    status: ""
};

const ProductManagement = () => {

    const [iState, updateState] = useState(initialState);
    const {
        Deleteshow,
        productsData,
        BlockModal,
        UnblockModal,
        _id,
        search,
        sub_category_Id,
        store,
        productId, status
    } = iState;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let storeId = JSON.parse(localStorage.getItem("storeDetailsId"));
    const { productList, subCategoryData } = useSelector((state) => state.product);
    // console.log("productList.....", productList);
    useEffect(() => {
        // dispatch(ProductListAction())
        dispatch(subCategoryList())
    }, [])

    useEffect(() => {
        getProductListFun();
        dispatch(ProductListAction({ search: "", sub_category_Id: "" }))
    }, []);

    useEffect(() => {
        fetchData()
    }, [productList]);

    const fetchData = () => {
        if (productList.status == 505) {
            navigate("/");
            toast.error(productList.message, {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    }



    const handleDeleteClose = () => {
        updateState({ ...iState, Deleteshow: false, _id: "" });
    };
    const handleDeleteShow = (_id) => {

        updateState({ ...iState, Deleteshow: true, _id });
    };

    // const [BlockModal, setBlockShow] = useState(false);
    const handleBlockClose = (_id, status) => {
        updateState({ ...iState, BlockModal: false, _id: "", status: "" });
    };
    const handleBlockShow = (_id, status) => {

        updateState({ ...iState, BlockModal: true, _id, status });
    };

    // const [UnblockModal, setUnblockShow] = useState(false);
    const handleUnblockClose = () => {
        updateState({ ...iState, UnblockModal: false, _id: "", status: "" });
    };
    const handleUnblockShow = (_id, status) => {

        updateState({ ...iState, UnblockModal: true, _id, status });
    };


    const handleInput = (e) => {
        const { name, value } = e.target;
        updateState({ ...iState, [name]: value })
    }




    const getProductListFun = () => {
        let data = {
            search,
            sub_category_Id,

        };
        dispatch(ProductListAction(data))
            .then((res) => {
                // console.log("res.dattgtrgta--->", res.data);
                if (res.status === 200) {

                    updateState({ ...iState, });
                }
            })
            .catch((err) => {
                toast.error(err.message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            });
    };

    const deleteProductFun = () => {

        let data = { _id };
        dispatch(removeProductAction(data)).then((res) => {
            if (res.status === 200) {
                toast.success(" Delete Product Successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                updateState(initialState);
                dispatch(ProductListAction())
            }
        });

    };

    const getProductId = (_id) => {

        localStorage.setItem("productId", JSON.stringify(_id));
        navigate("/product-edit");
    };

    const hanldeRefresh = () => {
        updateState(initialState);
        dispatch(ProductListAction())
            .then((res) => {
                if (res.status === 200) {
                    updateState({ ...iState, productsData: res?.data, search: "", sub_category_Id: "" });
                }
            })
    }

    const changeStatus = () => {
        let data = {
            productId: _id,
            status
        }
        let payloadData = {
            search,
            sub_category_Id,
            store: storeId,
        };
        dispatch(productStatusAction(data)).then((res) => {
            if (res.status === 200) {
                toast.success(res.message, {
                    position: toast.POSITION.TOP_RIGHT,
                })
                dispatch(ProductListAction(payloadData)).then((res) => {

                    if (res.status === 200) {
                        // toast.success(res.message, {
                        //   position: toast.POSITION.TOP_RIGHT,
                        // });
                        updateState({
                            ...iState,
                            productsData: res.data,
                            BlockModal: false,
                            UnblockModal: false
                        });
                    }
                });
            }

        }).catch((err) => {
            toast.error(err.message, {
                position: toast.POSITION.TOP_RIGHT,
            });
            updateState({
                ...iState,
                BlockModal: false,
                UnblockModal: false
            });
        })
    }

    // console.log(subCategoryData)
    // console.log("categoryDropDown------>", productList)
    return (
        <div>
            <Header />
            <SideNav />
            <div class="WrapperArea">
                <div class="WrapperBox">
                    <div class="TitleBox">
                        <div>
                            <h4 class="Title">Product Management</h4>
                        </div>
                    </div>

                    <div className="Small-Wrapper">
                        <div class="TitleBox">
                            <div class="FilterMain">
                                <div class="form-group">
                                    <label>Search</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="product Name..."
                                        name="search"
                                        value={search}
                                        disabled={sub_category_Id ?? search}
                                        onChange={handleInput}
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Select</label>
                                    <select class="form-control" name="sub_category_Id" value={sub_category_Id} onChange={handleInput} disabled={search ?? sub_category_Id}>
                                        <option value="">Select</option>
                                        {
                                            subCategoryData?.data?.length > 0 &&
                                            subCategoryData?.data?.map((ele) => (
                                                // console.log("ele", ele)
                                                <option value={ele?._id}>

                                                    {ele?.sub_category_name}
                                                </option>
                                            ))}
                                    </select>


                                </div>
                                <div class="form-group ">
                                    <label>&nbsp;</label>
                                    <button class="Button AddButton d-inline" onClick={getProductListFun}>Apply</button>
                                    <button class="Button AddButton d-inline" onClick={hanldeRefresh} > <i className="fa fa-refresh"></i> </button>
                                </div>

                            </div>
                            <div class="form-group ">
                                <label>&nbsp;</label>
                                <Link to="/product-add" className="Button ">+ Add Product</Link>
                            </div>

                        </div>
                        {
                            productList?.data?.length > 0 ?
                            productList?.data?.map((ele, index) => (
                                <div className="ProductBox">
                                    <div className="LeftBox">
                                        <figure>
                                            {ele?.image ? (
                                                <>
                                                    {" "}
                                                    <img src={ele?.image} />
                                                </>
                                            ) : (
                                                <>
                                                    {" "}
                                                    <img src={Product2} />
                                                </>
                                            )}
                                        </figure>
                                        <figcaption>
                                            <aside>
                                                <h5>
                                                    {ele?.product_name}{" "}
                                                </h5>
                                                <span>
                                                    <button
                                                        onClick={() => getProductId(ele?._id)}
                                                        class="Blue"
                                                    >
                                                        <i
                                                            class="fa fa-pencil-square-o"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </button>
                                                    <button
                                                        class="Blue"
                                                        onClick={() => handleDeleteShow(ele?._id)}
                                                    >
                                                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                                                    </button>
                                                    {ele?.status === "Active" ? (
                                                        <label className="Switch">
                                                            <input
                                                                type="checkbox"
                                                                checked={true}
                                                                onChange={() =>
                                                                    handleBlockShow(ele?._id, "Inactive")
                                                                }
                                                            />
                                                            <span className="slider"></span>
                                                        </label>
                                                    ) : (
                                                        <label className="Switch">
                                                            <input
                                                                type="checkbox"
                                                                checked={false}
                                                                onChange={() =>
                                                                    handleUnblockShow(ele?._id, "Active")
                                                                }
                                                            />
                                                            <span className="slider"></span>
                                                        </label>
                                                    )}
                                                </span>
                                            </aside>
                                            <p>{ele?.description}</p>
                                        </figcaption>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="SizeBox">
                                                <h6>Size options-</h6>

                                                <figcaption>
                                                    <ol>


                                                        {ele?.productVariants &&
                                                            ele?.productVariants.length > 0 &&
                                                            ele?.productVariants.map((item) => (
                                                                <>
                                                                    <li>
                                                                        <div className="SizeMain">
                                                                            <label>{item?.size} ({item?.desc}){" "} </label>
                                                                        </div>
                                                                        <article>
                                                                            <aside>
                                                                                {item?.discountedPrice ?
                                                                                    <>
                                                                                        <label>
                                                                                            SAR {item?.discountedPrice}{" "}
                                                                                            (discountedPrice)
                                                                                        </label>
                                                                                    </> : <></>

                                                                                }
                                                                            </aside>
                                                                            <aside>  <span> SAR {item?.price} (Available stocks:
                                                                                {item?.stock})  {item?.default ? (
                                                                                    <button>
                                                                                        {" "}
                                                                                        <img src={CheckImg} />
                                                                                    </button>
                                                                                ) : (
                                                                                    <></>
                                                                                )} </span></aside>
                                                                        </article>

                                                                    </li>
                                                                </>
                                                            ))}


                                                    </ol>
                                                </figcaption>
                                            </div>
                                        </div>

                                        {ele?.addOns.some((x) => x.charges) &&
                                            ele?.addOns.some((x) => x.name) ? (
                                            <>
                                                <div className="col-sm-6">
                                                    <div className="SizeBox">
                                                        <h6>Add Ons-</h6>
                                                        <figcaption>
                                                            {ele?.addOns &&
                                                                ele?.addOns.length > 0 &&
                                                                ele?.addOns.map((item, index) =>
                                                                    item.name && item?.charges ? (
                                                                        <>
                                                                      

                                                                            <ul>
                                                                                <li>
                                                                                    <label>{item?.name} </label>
                                                                                    <span>
                                                                                        {" "}
                                                                                        {item?.charges ? (
                                                                                            <>SAR {item?.charges}</>
                                                                                        ) : (
                                                                                            <></>
                                                                                        )}
                                                                                    </span>
                                                                                </li>
                                                                            </ul>
                                                                        </>
                                                                    ) : (
                                                                        <></>
                                                                    )
                                                                )}
                                                        </figcaption>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                       
                                        {ele?.choices.some((x) => x.charges) &&
                                            ele?.choices.some((x) => x.name) ? (
                                            <>
                                                <div className="col-sm-6">
                                                    <div className="SizeBox">
                                                        <h6>Add More Choice-</h6>
                                                        <figcaption>
                                                            {ele?.choices &&
                                                                ele?.choices.length > 0 &&
                                                                ele?.choices.map((ele) => (
                                                                    // console.log(ele)
                                                                    <ul>
                                                                        <>
                                                                            <li>
                                                                                <label>{ele?.name} </label>
                                                                                <span>
                                                                                    {" "}
                                                                                    {ele?.charges ? (
                                                                                        <>SAR {ele?.charges}</>
                                                                                    ) : (
                                                                                        <></>
                                                                                    )}{" "}
                                                                                </span>
                                                                            </li>
                                                                        </>
                                                                    </ul>
                                                                ))}
                                                            <li></li>
                                                        </figcaption>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <></>
                                        )}

                                    </div>
                                </div>
                            )):
                            <>
                            <h2 className="MainMessage">Data not Found !!!</h2>
                            </>}

                    </div>
                </div>
            </div>
            <div>
                <Modal
                    show={Deleteshow}
                    onHide={handleDeleteClose}
                    className="ModalBox "
                >
                    <Modal.Body>
                        <div class="Decline">
                            <button class="CloseModal" onClick={handleDeleteClose}>
                                ×
                            </button>
                            <h3>Delete</h3>
                            <figure>
                                <img src={DeleteAlert} />
                            </figure>
                            <p>Are you sure you want to Delete this Product ?</p>
                            <h4>
                                <button class="Cancel" onClick={handleDeleteClose}>
                                    Cancel
                                </button>
                                <button onClick={deleteProductFun}>Delete</button>
                            </h4>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={UnblockModal} className="ModalBox ">
                    <Modal.Body>
                        <div class="Decline">
                            <button class="CloseModal" onClick={handleUnblockClose}>
                                ×
                            </button>
                            <h3>Unblock</h3>
                            <figure>
                                <img src={Alert} />
                            </figure>
                            <p>Are you sure you want to Unblock this Product ?</p>
                            <h4>
                                <button onClick={handleUnblockClose} class="Cancel">
                                    Cancel
                                </button>
                                <button onClick={changeStatus}>Unblock</button>
                            </h4>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={BlockModal} className="ModalBox ">
                    <Modal.Body>
                        <div class="Decline">
                            <button class="CloseModal" onClick={handleBlockClose}>
                                ×
                            </button>
                            <h3>Block</h3>
                            <figure>
                                <img src={Alert} />
                            </figure>
                            <p>Are you sure you want to block this Product ?</p>
                            <h4>
                                <button onClick={handleBlockClose} class="Cancel">
                                    Cancel
                                </button>
                                <button onClick={changeStatus}>Block</button>
                            </h4>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
}
export default ProductManagement